// @ts-nocheck
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useGetUserReportFileQuery} from '../../../../../../api'
import {useListView} from '../../core/ListViewProvider'
import {UsersListFilter} from './UsersListFilter'
import React, {useState, useCallback} from 'react'
import {BASE_URL} from '../../../../../../api'
import * as XLSX from 'xlsx'
import moment from 'moment'
import axios from 'axios'

// First and last name as separate columns (for Mailchimp imports). If only
// one name field was filled in with a full name ("Maria Lopez"), split it at
// the first space. Missing names stay blank rather than "N/A".
const splitName = (u) => {
  let first = String(u?.firstName || '').trim()
  let last = String(u?.lastName || '').trim()
  if (!last && first.includes(' ')) {
    const i = first.indexOf(' ')
    last = first.slice(i + 1).trim()
    first = first.slice(0, i)
  } else if (!first && last.includes(' ')) {
    const i = last.indexOf(' ')
    first = last.slice(0, i)
    last = last.slice(i + 1).trim()
  }
  return {first, last}
}

const downloadExcel = (data) => {
  if (!data || data.length === 0) {
    alert('No data available to export')
    return
  }

  console.log('Exporting filtered transactions data:', {
    totalRecords: data.length,
    data: data,
  })

  // Transform data to match the desired export format
  const transformedData = data.map((transaction) => {
    // First and last name in separate columns
    const {first, last} = splitName(transaction.user)

    // Format transaction ID (stripe_id)
    const transaction_id = transaction.stripeId || transaction._id || 'N/A'

    // Format amount
    const amount = transaction.amount || 0

    // Format date using moment (same format as table display)
    const date = transaction.createdAt
      ? moment(new Date(transaction.createdAt)).format('lll')
      : 'N/A'

    return {
      'First Name': first,
      'Last Name': last,
      Email: transaction.user?.email || '',
      'Transaction ID': transaction_id,
      Amount: amount,
      Date: date,
    }
  })

  console.log('Transformed data for export:', transformedData)

  const worksheet = XLSX.utils.json_to_sheet(transformedData)
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Transactions')

  // Add filename with filter info
  const fileName = `TransactionsData_${moment().format('YYYY-MM-DD_HH-mm')}.xlsx`
  XLSX.writeFile(workbook, fileName)
}

const UsersListToolbar = ({
  page,
  setPage,
  sDate,
  setSDate,
  setEDate,
  eDate,
  genderFilter,
  setGenderFilter,
  loading,
  setLoading,
  applyFilter,
  setApplyFilter,
  transactionsData,
}) => {
  const {setItemIdForUpdate} = useListView()
  const [exportLoading, setExportLoading] = useState(false)

  const openAddUserModal = useCallback(() => {
    setItemIdForUpdate(null)
  }, [setItemIdForUpdate])

  const handleExport = useCallback(async () => {
    if (loading) {
      alert('Please wait for data to load before exporting')
      return
    }

    try {
      setExportLoading(true)
      console.log('Starting export of all filtered transactions data...')

      // Make API call to get ALL filtered data (not just current page)
      const response = await axios.get(`${BASE_URL}/admin/transactions`, {
        params: {
          page: 1, // Start from page 1
          limit: 10000, // Set a very high limit to get all data
          query: '', // No search filter for export
          startDate: sDate || '',
          endDate: eDate || '',
          // Remove pagination to get all results
          export: true, // Add flag to indicate this is for export
        },
      })

      const {docs} = response.data
      console.log('Export API response - Total filtered records:', docs.length)

      if (!docs || docs.length === 0) {
        alert('No data found matching the current filters')
        return
      }

      // Export all filtered data
      downloadExcel(docs)
    } catch (error) {
      console.error('Error during export:', error)
      alert('Error occurred while exporting data. Please try again.')
    } finally {
      setExportLoading(false)
    }
  }, [loading, sDate, eDate])

  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      <UsersListFilter
        genderFilter={genderFilter}
        setGenderFilter={setGenderFilter}
        sDate={sDate}
        setSDate={setSDate}
        setEDate={setEDate}
        eDate={eDate}
        page={page}
        setPage={setPage}
        loading={loading}
        setLoading={setLoading}
        applyFilter={applyFilter}
        setApplyFilter={setApplyFilter}
      />

      {/* begin::Export Options */}
      <div className='d-flex flex-column me-3'>
        {/* Filter Info Message
        {transactionsData && transactionsData.length > 0 && (
          <div className='text-muted fs-7 mb-2 text-center'>
            📊 Current page: {transactionsData.length} transactions
            {sDate && eDate && (
              <span className='ms-2'>
                • Date: {moment(sDate).format('MMM DD')} - {moment(eDate).format('MMM DD, YYYY')}
              </span>
            )}
            <div className='text-info mt-1'>
              ⚠️ Export will include ALL filtered data across all pages
            </div>
          </div>
        )} */}

        {/* Export Button */}
        <button
          type='button'
          className='btn btn-light-primary'
          onClick={handleExport}
          disabled={loading || exportLoading}
          title='Export ALL filtered transaction records to Excel (across all pages)'
        >
          <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
          <span>{exportLoading ? 'Exporting...' : 'Export All'}</span>
        </button>
      </div>
      {/* end::Export Options */}

      {/* begin::Add user */}
      {/* <button type='button' className='btn btn-primary' onClick={openAddUserModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        Add User
      </button> */}
      {/* end::Add user */}
    </div>
  )
}

export {UsersListToolbar}
